// // // // import React, { useState, useEffect } from "react";
// // // // import { Box, Typography, Paper, CircularProgress } from "@mui/material";
// // // // import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// // // // import axiosClient from "../axiosClient";
// // // // import { useTranslation } from "react-i18next";

// // // // const StaffPerformance = () => {
// // // //     const { t } = useTranslation();
// // // //     const [data, setData] = useState([]);
// // // //     const [loading, setLoading] = useState(true);

// // // //     useEffect(() => {
// // // //         axiosClient.get("/api/staff-performance-stats/")
// // // //             .then(res => {
// // // //                 setData(res.data);
// // // //                 setLoading(false);
// // // //             })
// // // //             .catch(err => {
// // // //                 console.error(err);
// // // //                 setLoading(false);
// // // //             });
// // // //     }, []);

// // // //     return (
// // // //         <Box sx={{ p: 3, color: 'white' }}>
// // // //             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
// // // //                 {t("Staff Performance Metrics")}
// // // //             </Typography>

// // // //             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', borderRadius: 2, minHeight: 500 }}>
// // // //                 <Typography variant="h6" align="center" gutterBottom sx={{ color: '#8884d8' }}>
// // // //                     {t("Issues Handled per Staff Member")}
// // // //                 </Typography>

// // // //                 {loading ? (
// // // //                     <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
// // // //                         <CircularProgress />
// // // //                     </Box>
// // // //                 ) : data.length > 0 ? (
// // // //                     <ResponsiveContainer width="100%" height={450}>
// // // //                         <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
// // // //                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
// // // //                             <XAxis 
// // // //                                 dataKey="name" 
// // // //                                 stroke="#ccc" 
// // // //                                 angle={-45} 
// // // //                                 textAnchor="end" 
// // // //                                 interval={0} 
// // // //                                 height={80} 
// // // //                             />
// // // //                             <YAxis stroke="#ccc" />
// // // //                             <Tooltip 
// // // //                                 contentStyle={{ backgroundColor: '#2d2d44', border: 'none', borderRadius: '8px' }}
// // // //                                 itemStyle={{ color: '#fff' }}
// // // //                             />
// // // //                             <Legend verticalAlign="top" height={36}/>
// // // //                             <Bar 
// // // //                                 dataKey="total" 
// // // //                                 name={t("Total Issues")} 
// // // //                                 fill="#8884d8" 
// // // //                                 radius={[4, 4, 0, 0]} 
// // // //                             />
// // // //                         </BarChart>
// // // //                     </ResponsiveContainer>
// // // //                 ) : (
// // // //                     <Typography align="center" sx={{ mt: 10, color: '#aaa' }}>
// // // //                         {t("No data available for staff performance.")}
// // // //                     </Typography>
// // // //                 )}
// // // //             </Paper>
// // // //         </Box>
// // // //     );
// // // // };

// // // // export default StaffPerformance;


// // // import React, { useState, useEffect } from "react";
// // // import { Box, Typography, Paper, Grid, TextField } from "@mui/material";
// // // import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// // // import axiosClient from "../axiosClient";
// // // import dayjs from "dayjs";

// // // const StaffPerformance = () => {
// // //     const [data, setData] = useState([]);
// // //     const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM"));

// // //     const fetchPerformance = async (date) => {
// // //         // Calculate start and end of the month
// // //         const start = dayjs(date).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(date).endOf('month').format("YYYY-MM-DD");

// // //         try {
// // //             const res = await axiosClient.get("/api/staff-performance-stats/", {
// // //                 params: { start, end }
// // //             });
// // //             setData(res.data);
// // //         } catch (err) {
// // //             console.error(err);
// // //         }
// // //     };

// // //     useEffect(() => {
// // //         fetchPerformance(selectedDate);
// // //     }, [selectedDate]);

// // //     return (
// // //         <Box sx={{ p: 3 }}>
// // //              {/* 🛠️ DATE FILTERS (Matches your image_9cc11a.png) */}
// // //             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f' }}>
// // //                 <Grid container spacing={2}>
// // //                     <Grid item xs={12} md={4}>
// // //                         <Typography variant="caption" sx={{ color: 'white' }}>Select Month for Performance</Typography>
// // //                         <TextField 
// // //                             type="month" 
// // //                             fullWidth 
// // //                             value={selectedDate}
// // //                             onChange={(e) => setSelectedDate(e.target.value)}
// // //                             sx={{ input: { color: 'white' }, bgcolor: '#2d2d44' }}
// // //                         />
// // //                     </Grid>
// // //                 </Grid>
// // //             </Paper>

// // //             <Paper sx={{ p: 4, bgcolor: '#1e1e2f' }}>
// // //                 <Typography variant="h6" align="center" sx={{ color: '#8884d8', mb: 2 }}>Issues Handled per Staff Member</Typography>
// // //                 <ResponsiveContainer width="100%" height={400}>
// // //                     {/* <BarChart data={data}>
// // //                         <CartesianGrid strokeDasharray="3 3" stroke="#444" />
// // //                         <XAxis dataKey="name" stroke="#ccc" />
// // //                         <YAxis stroke="#ccc" />
// // //                         <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
// // //                         <Bar dataKey="total" fill="#8884d8" name="Tasks Completed" />
// // //                     </BarChart> */}
// // //                     <BarChart data={data}>
// // //                         <CartesianGrid strokeDasharray="3 3" stroke="#444" />
// // //                         {/* The dataKey must be exactly "name" */}
// // //                         <XAxis dataKey="name" stroke="#ccc" fontSize={12} tick={{fill: '#ccc'}} />
// // //                         <YAxis stroke="#ccc" tick={{fill: '#ccc'}} />
// // //                         <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none', color: '#fff' }} />
// // //                         {/* The dataKey must be exactly "total" */}
// // //                         <Bar dataKey="total" fill="#8884d8" radius={[4, 4, 0, 0]} />
// // //                         </BarChart>
// // //                 </ResponsiveContainer>
// // //             </Paper>
// // //         </Box>
// // //     );
// // // };

// // // export default StaffPerformance;


// // import React, { useState, useEffect, useCallback } from "react";
// // import { Box, Typography, Paper, Grid, TextField, CircularProgress } from "@mui/material";
// // import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// // import axiosClient from "../axiosClient";
// // import dayjs from "dayjs";
// // import { useTranslation } from "react-i18next";

// // const StaffPerformance = () => {
// //     const { t } = useTranslation();
// //     const [data, setData] = useState([]);
// //     const [loading, setLoading] = useState(false);
// //     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

// //     const fetchStats = useCallback(async () => {
// //         setLoading(true);
// //         // Calculate the first and last day of the selected month
// //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

// //         try {
// //             const response = await axiosClient.get("/api/staff-performance-stats/", {
// //                 params: { start, end }
// //             });
// //             setData(response.data);
// //         } catch (error) {
// //             console.error("Error fetching performance:", error);
// //             setData([]);
// //         } finally {
// //             setLoading(false);
// //         }
// //     }, [selectedMonth]);

// //     // 🛠️ This ensures the chart updates when you pick a new month
// //     useEffect(() => {
// //         fetchStats();
// //     }, [fetchStats]);

// //     return (
// //         <Box sx={{ p: 3 }}>
// //             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', borderRadius: 2 }}>
// //                 <Grid container spacing={2} alignItems="center">
// //                     <Grid item xs={12} md={4}>
// //                         <Typography variant="subtitle2" sx={{ color: '#ccc', mb: 1 }}>
// //                             {t("Select Month for Performance")}
// //                         </Typography>
// //                         <TextField 
// //                             type="month" 
// //                             fullWidth 
// //                             value={selectedMonth}
// //                             onChange={(e) => setSelectedMonth(e.target.value)}
// //                             sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1 }}
// //                         />
// //                     </Grid>
// //                 </Grid>
// //             </Paper>

// //             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', borderRadius: 2, minHeight: 450 }}>
// //                 <Typography variant="h6" align="center" sx={{ color: '#8884d8', mb: 4 }}>
// //                     {t("Issues Handled per Staff Member")}
// //                 </Typography>

// //                 {loading ? (
// //                     <Box sx={{ display: 'flex', justifyContent: 'center', p: 10 }}><CircularProgress /></Box>
// //                 ) : data.length > 0 ? (
// //                     <ResponsiveContainer width="100%" height={400}>
// //                         <BarChart data={data} margin={{ bottom: 50 }}>
// //                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
// //                             <XAxis dataKey="name" stroke="#ccc" angle={-45} textAnchor="end" interval={0} />
// //                             <YAxis stroke="#ccc" />
// //                             <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
// //                             <Legend verticalAlign="top" height={36}/>
// //                             <Bar dataKey="total" fill="#8884d8" name={t("Issues Completed")} radius={[4, 4, 0, 0]} />
// //                         </BarChart>
// //                     </ResponsiveContainer>
// //                 ) : (
// //                     <Typography align="center" sx={{ color: '#666', mt: 10 }}>
// //                         {t("No data available for the selected period.")}
// //                     </Typography>
// //                 )}
// //             </Paper>
// //         </Box>
// //     );
// // };

// // export default StaffPerformance;

// import React, { useState, useEffect } from "react";
// import { Box, Typography, Paper, Grid, TextField, CircularProgress, Button } from "@mui/material";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//     const fetchStats = async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", {
//                 params: { start, end }
//             });
//             setData(response.data);
//         } catch (error) {
//             console.error("Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Auto-fetch when month changes
//     useEffect(() => {
//         fetchStats();
//     }, [selectedMonth]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f' }}>
//                 <Grid container spacing={2} alignItems="center">
//                     <Grid item xs={12} md={4}>
//                         <TextField 
//                             label={t("Select Month")}
//                             type="month" 
//                             fullWidth 
//                             value={selectedMonth}
//                             onChange={(e) => setSelectedMonth(e.target.value)}
//                             InputLabelProps={{ shrink: true }}
//                             sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1 }}
//                         />
//                     </Grid>
//                     <Grid item xs={12} md={2}>
//                         <Button variant="contained" onClick={fetchStats} fullWidth>
//                             {t("PRESENT DATA")}
//                         </Button>
//                     </Grid>
//                 </Grid>
//             </Paper>

//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', minHeight: 450, borderRadius: 2 }}>
//                 {loading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', p: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
//                             <Legend />
//                             <Bar dataKey="total" fill="#8884d8" name={t("Tasks Completed")} radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Box sx={{ textAlign: 'center', py: 10 }}>
//                         <Typography color="textSecondary">{t("No data available for this month")}</Typography>
//                     </Box>
//                 )}
//             </Paper>
//         </Box>
//     );
// };

// export default StaffPerformance;


////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import { 
//   Box, Typography, Paper, Grid, TextField, Button, 
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//   CircularProgress, IconButton 
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); // Bar Chart Data
//     const [details, setDetails] = useState([]); // Catalog/Table Data
//     const [loading, setLoading] = useState(false);
//     const [modalOpen, setModalOpen] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//     // 1. Fetch data for the Chart
//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", {
//                 params: { start, end }
//             });
//             setData(response.data);
//         } catch (error) {
//             console.error("Chart Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     // 2. Fetch detailed data for the "Catalog" Modal
//     const handleOpenCatalog = async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", {
//                 params: { start, end }
//             });
//             setDetails(response.data);
//             setModalOpen(true);
//         } catch (error) {
//             console.error("Catalog Fetch Error:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             {/* --- FILTER & ACTION BAR --- */}
//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 250 }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading}>
//                         {t("PRESENT DATA")}
//                     </Button>
//                 </Box>
                
//                 {/* 🛠️ NEW CATALOG BUTTON */}
//                 <Button 
//                     variant="contained" 
//                     color="secondary" 
//                     onClick={handleOpenCatalog}
//                     disabled={loading}
//                 >
//                     {t("VIEW CATALOG DETAILS")}
//                 </Button>
//             </Paper>

//             {/* --- CHART SECTION --- */}
//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', minHeight: 450, borderRadius: 2 }}>
//                 {loading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
//                             <Legend />
//                             <Bar dataKey="total" fill="#8884d8" name={t("Issues Completed")} radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available for this month")}</Typography>
//                 )}
//             </Paper>

//             {/* --- 🛠️ CATALOG MODAL POPUP --- */}
//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '90%', maxWidth: 1000, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, 
//                     boxShadow: 24, color: 'white', border: '1px solid #3d3d5c'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                         <Typography variant="h6">{t("Issue Resolution Catalog")}</Typography>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}>
//                             <CloseIcon />
//                         </IconButton>
//                     </Box>

//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Reported")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Resolved")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {details.map((row, i) => (
//                                     <TableRow key={i} hover sx={{ '&:hover': { bgcolor: '#3d3d5c !important' } }}>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.room}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.staff}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.issue}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.reported}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.resolved}</TableCell>
//                                         <TableCell sx={{ color: '#8884d8', fontWeight: 'bold', borderBottom: '1px solid #3d3d5c' }}>{row.time_taken}</TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;


//////////////////////////////////////////////////////////////////////////


// import React, { useState, useEffect, useCallback } from "react";
// import { 
//   Box, Typography, Paper, Grid, TextField, Button, 
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//   CircularProgress, IconButton 
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); // Bar Chart Data
//     const [details, setDetails] = useState([]); // Catalog/Table Data
//     const [loading, setLoading] = useState(false);
//     const [modalOpen, setModalOpen] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//     // ✅ Helper function to format time: shows minutes if < 1 hour
//     const formatTimeTaken = (timeValue) => {
//         const hours = parseFloat(timeValue);
        
//         if (isNaN(hours)) return timeValue;

//         // Convert hours to total minutes
//         const totalMinutes = Math.round(hours * 60);

//         if (totalMinutes < 0) {
//             return `0 ${t("mins")}`; // Cleanup for negative data
//         }

//         if (totalMinutes < 60) {
//             return `${totalMinutes} ${t("mins")}`;
//         }

//         return `${hours.toFixed(1)} ${t("hrs")}`;
//     };

//     // 1. Fetch data for the Chart
//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", {
//                 params: { start, end }
//             });
//             setData(response.data);
//         } catch (error) {
//             console.error("Chart Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     // 2. Fetch detailed data for the "Catalog" Modal
//     const handleOpenCatalog = async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", {
//                 params: { start, end }
//             });
//             setDetails(response.data);
//             setModalOpen(true);
//         } catch (error) {
//             console.error("Catalog Fetch Error:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             {/* --- FILTER & ACTION BAR --- */}
//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 250 }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading}>
//                         {t("PRESENT DATA")}
//                     </Button>
//                 </Box>
                
//                 <Button 
//                     variant="contained" 
//                     color="secondary" 
//                     onClick={handleOpenCatalog}
//                     disabled={loading}
//                 >
//                     {t("VIEW CATALOG DETAILS")}
//                 </Button>
//             </Paper>

//             {/* --- CHART SECTION --- */}
//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', minHeight: 450, borderRadius: 2 }}>
//                 {loading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
//                             <Legend />
//                             <Bar dataKey="total" fill="#8884d8" name={t("Issues Completed")} radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available for this month")}</Typography>
//                 )}
//             </Paper>

//             {/* --- CATALOG MODAL POPUP --- */}
//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '90%', maxWidth: 1000, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, 
//                     boxShadow: 24, color: 'white', border: '1px solid #3d3d5c'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                         <Typography variant="h6">{t("Issue Resolution Catalog")}</Typography>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}>
//                             <CloseIcon />
//                         </IconButton>
//                     </Box>

//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Reported")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Resolved")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {details.map((row, i) => (
//                                     <TableRow key={i} hover sx={{ '&:hover': { bgcolor: '#3d3d5c !important' } }}>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.room}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.staff}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.issue}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.reported}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.resolved}</TableCell>
//                                         {/* ✅ Applied the formatting function here */}
//                                         <TableCell sx={{ color: '#8884d8', fontWeight: 'bold', borderBottom: '1px solid #3d3d5c' }}>
//                                             {formatTimeTaken(row.time_taken)}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;



////////////////////////////////////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import { 
//   Box, Typography, Paper, Grid, TextField, Button, 
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//   CircularProgress, IconButton 
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); 
//     const [details, setDetails] = useState([]); 
//     const [loading, setLoading] = useState(false);
//     const [downloading, setDownloading] = useState(false); // New state for download button
//     const [modalOpen, setModalOpen] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//     const formatTimeTaken = (timeValue) => {
//         const hours = parseFloat(timeValue);
//         if (isNaN(hours)) return timeValue;
//         const totalMinutes = Math.round(hours * 60);
//         if (totalMinutes < 0) return `0 mins`;
//         if (totalMinutes < 60) return `${totalMinutes} mins`;
//         return `${hours.toFixed(1)} hrs`;
//     };

//     // ✅ FIXED: Downloads immediately by fetching data first
//     const downloadCatalogExcel = async () => {
//         setDownloading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             // Fetch data specifically for the download
//             const response = await axiosClient.get("/api/staff-issue-details/", {
//                 params: { start, end }
//             });
//             const freshDetails = response.data;

//             if (!freshDetails || freshDetails.length === 0) {
//                 alert(t("No data found for this month."));
//                 return;
//             }

//             // Define headers
//             const headers = ["Room", "Staff", "Issue", "Reported", "Resolved", "Time Taken"];
            
//             // Map data rows
//             const rows = freshDetails.map(row => [
//                 row.room,
//                 row.staff,
//                 `"${row.issue.replace(/"/g, '""')}"`, // Escape quotes for CSV
//                 row.reported,
//                 row.resolved,
//                 formatTimeTaken(row.time_taken)
//             ]);

//             const csvContent = [
//                 headers.join(","),
//                 ...rows.map(e => e.join(","))
//             ].join("\n");

//             const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
//             const url = URL.createObjectURL(blob);
//             const link = document.createElement("a");
//             link.setAttribute("href", url);
//             link.setAttribute("download", `Staff_Performance_Catalog_${selectedMonth}.csv`);
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
            
//             // Also update the local state so the modal is ready if they DO want to open it later
//             setDetails(freshDetails);

//         } catch (error) {
//             console.error("Download Error:", error);
//             alert("Failed to generate download.");
//         } finally {
//             setDownloading(false);
//         }
//     };

//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", { params: { start, end } });
//             setData(response.data);
//         } catch (error) {
//             console.error("Chart Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     const handleOpenCatalog = async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", { params: { start, end } });
//             setDetails(response.data);
//             setModalOpen(true);
//         } catch (error) {
//             console.error("Catalog Fetch Error:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 200 }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading}>
//                         {t("PRESENT DATA")}
//                     </Button>
//                 </Box>
                
//                 <Box sx={{ display: 'flex', gap: 2 }}>
//                     <Button 
//                         variant="contained" 
//                         color="secondary" 
//                         onClick={handleOpenCatalog}
//                         disabled={loading || downloading}
//                     >
//                         {t("VIEW CATALOG DETAILS")}
//                     </Button>

//                     <Button 
//                         variant="contained" 
//                         color="success" 
//                         startIcon={downloading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadIcon />}
//                         onClick={downloadCatalogExcel}
//                         disabled={loading || downloading}
//                     >
//                         {downloading ? t("DOWNLOADING...") : t("DOWNLOAD EXCEL")}
//                     </Button>
//                 </Box>
//             </Paper>

//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', minHeight: 450, borderRadius: 2 }}>
//                 {loading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
//                             <Legend />
//                             <Bar dataKey="total" fill="#8884d8" name={t("Issues Completed")} radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available for this month")}</Typography>
//                 )}
//             </Paper>

//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '90%', maxWidth: 1000, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, 
//                     boxShadow: 24, color: 'white', border: '1px solid #3d3d5c'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                         <Typography variant="h6">{t("Issue Resolution Catalog")}</Typography>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}>
//                             <CloseIcon />
//                         </IconButton>
//                     </Box>

//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Reported")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Resolved")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {details.map((row, i) => (
//                                     <TableRow key={i} hover sx={{ '&:hover': { bgcolor: '#3d3d5c !important' } }}>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.room}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.staff}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.issue}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.reported}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.resolved}</TableCell>
//                                         <TableCell sx={{ color: '#8884d8', fontWeight: 'bold', borderBottom: '1px solid #3d3d5c' }}>
//                                             {formatTimeTaken(row.time_taken)}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;

/////////////////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import { 
//   Box, Typography, Paper, TextField, Button, 
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//   CircularProgress, IconButton 
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); 
//     const [details, setDetails] = useState([]); 
//     const [loading, setLoading] = useState(false);
//     const [downloading, setDownloading] = useState(false); 
//     const [modalOpen, setModalOpen] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//     // ✅ Formats hours into minutes if under 1 hour
//     const formatTimeTaken = (timeValue) => {
//         const hours = parseFloat(timeValue);
//         if (isNaN(hours)) return timeValue;
//         const totalMinutes = Math.round(hours * 60);
//         if (totalMinutes <= 0) return `0 ${t("mins")}`;
//         if (totalMinutes < 60) return `${totalMinutes} ${t("mins")}`;
//         return `${hours.toFixed(1)} ${t("hrs")}`;
//     };

//     // ✅ PROFESSIONAL DOWNLOAD LOGIC (Semicolon Separated for Excel Columns)
//     const downloadCatalogExcel = async () => {
//         setDownloading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", {
//                 params: { start, end }
//             });
//             const freshDetails = response.data;

//             if (!freshDetails || freshDetails.length === 0) {
//                 alert(t("No data found for this month."));
//                 return;
//             }

//             // Define Table Headers
//             const headers = [t("Room"), t("Staff"), t("Issue"), t("Reported"), t("Resolved"), t("Time Taken")];
            
//             // Map rows using Semicolon (;). 
//             // Most European Excel versions use ; to separate columns.
//             const rows = freshDetails.map(row => [
//                 String(row.room || '').replace(/;/g, ' '),
//                 String(row.staff || '').replace(/;/g, ' '),
//                 String(row.issue || '').replace(/;/g, ' '), // Clean out any semicolons in the text
//                 String(row.reported || ''),
//                 String(row.resolved || ''),
//                 formatTimeTaken(row.time_taken)
//             ]);

//             // Combine into string with Semicolon separators
//             const content = [
//                 headers.join(";"),
//                 ...rows.map(e => e.join(";"))
//             ].join("\n");

//             // BOM (\ufeff) + CSV content. 
//             // The BOM forces Excel to open it correctly in separate columns immediately.
//             const blob = new Blob(["\ufeff" + content], { type: 'text/csv;charset=utf-8;' });
//             const url = URL.createObjectURL(blob);
//             const link = document.createElement("a");
            
//             link.href = url;
//             link.download = `Staff_Performance_Report_${selectedMonth}.csv`; 
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
            
//             setDetails(freshDetails);

//         } catch (error) {
//             console.error("Download Error:", error);
//             if (error.response?.status === 401) {
//                 alert("Session expired. Please logout and login again.");
//             } else {
//                 alert("Failed to generate report.");
//             }
//         } finally {
//             setDownloading(false);
//         }
//     };

//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", { params: { start, end } });
//             setData(response.data);
//         } catch (error) {
//             console.error("Chart Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     const handleOpenCatalog = async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", { params: { start, end } });
//             setDetails(response.data);
//             setModalOpen(true);
//         } catch (error) {
//             console.error("Catalog Fetch Error:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 200 }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading || downloading}>
//                         {t("PRESENT DATA")}
//                     </Button>
//                 </Box>
                
//                 <Box sx={{ display: 'flex', gap: 2 }}>
//                     <Button variant="contained" color="secondary" onClick={handleOpenCatalog} disabled={loading || downloading}>
//                         {t("VIEW CATALOG DETAILS")}
//                     </Button>

//                     <Button 
//                         variant="contained" 
//                         color="success" 
//                         startIcon={downloading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadIcon />}
//                         onClick={downloadCatalogExcel}
//                         disabled={loading || downloading}
//                     >
//                         {downloading ? t("DOWNLOADING...") : t("DOWNLOAD EXCEL")}
//                     </Button>
//                 </Box>
//             </Paper>

//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', minHeight: 450, borderRadius: 2 }}>
//                 {loading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
//                             <Legend />
//                             <Bar dataKey="total" fill="#8884d8" name={t("Issues Completed")} radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available for this month")}</Typography>
//                 )}
//             </Paper>

//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '90%', maxWidth: 1000, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, 
//                     boxShadow: 24, color: 'white', border: '1px solid #3d3d5c'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                         <Typography variant="h6">{t("Issue Resolution Catalog")}</Typography>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}>
//                             <CloseIcon />
//                         </IconButton>
//                     </Box>

//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Reported")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Resolved")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {details.map((row, i) => (
//                                     <TableRow key={i} hover sx={{ '&:hover': { bgcolor: '#3d3d5c !important' } }}>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.room}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.staff}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.issue}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.reported}</TableCell>
//                                         <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.resolved}</TableCell>
//                                         <TableCell sx={{ color: '#8884d8', fontWeight: 'bold', borderBottom: '1px solid #3d3d5c' }}>
//                                             {formatTimeTaken(row.time_taken)}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;


///////////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import { 
//     Box, Typography, Paper, TextField, Button, 
//     Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//     CircularProgress, IconButton 
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); 
//     const [details, setDetails] = useState([]); 
//     const [loading, setLoading] = useState(false);
//     const [downloading, setDownloading] = useState(false); 
//     const [modalOpen, setModalOpen] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//     // ✅ Formats hours into minutes if under 1 hour
//     const formatTimeTaken = (timeValue) => {
//         const hours = parseFloat(timeValue);
//         if (isNaN(hours)) return timeValue;
//         const totalMinutes = Math.round(hours * 60);
//         if (totalMinutes <= 0) return `0 ${t("mins")}`;
//         if (totalMinutes < 60) return `${totalMinutes} ${t("mins")}`;
//         return `${hours.toFixed(1)} ${t("hrs")}`;
//     };

//     // ✅ FETCH CATALOG DETAILS (The Modal Table)
//     const fetchCatalogDetails = async (targetMonth) => {
//         setLoading(true);
//         const start = dayjs(targetMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(targetMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", { 
//                 params: { start, end } 
//             });
//             setDetails(response.data);
//         } catch (error) {
//             console.error("Catalog Fetch Error:", error);
//             setDetails([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ✅ FETCH CHART STATS (The Main Bar Chart)
//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", { 
//                 params: { start, end } 
//             });
//             setData(response.data);
//         } catch (error) {
//             console.error("Chart Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     // ✅ DOWNLOAD EXCEL LOGIC
//     const downloadCatalogExcel = async () => {
//         setDownloading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");

//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", {
//                 params: { start, end }
//             });
//             const freshDetails = response.data;

//             if (!freshDetails || freshDetails.length === 0) {
//                 alert(t("No data found for this month."));
//                 return;
//             }

//             const headers = [t("Room"), t("Staff"), t("Issue"), t("Reported"), t("Resolved"), t("Time Taken")];
//             const rows = freshDetails.map(row => [
//                 String(row.room || '').replace(/;/g, ' '),
//                 String(row.staff || '').replace(/;/g, ' '),
//                 String(row.issue || '').replace(/;/g, ' '),
//                 String(row.reported || ''),
//                 String(row.resolved || ''),
//                 formatTimeTaken(row.time_taken)
//             ]);

//             const content = [headers.join(";"), ...rows.map(e => e.join(";"))].join("\n");
//             const blob = new Blob(["\ufeff" + content], { type: 'text/csv;charset=utf-8;' });
//             const url = URL.createObjectURL(blob);
//             const link = document.createElement("a");
//             link.href = url;
//             link.download = `Staff_Performance_Report_${selectedMonth}.csv`; 
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//         } catch (error) {
//             alert("Failed to generate report.");
//         } finally {
//             setDownloading(false);
//         }
//     };

//     const handleOpenCatalog = () => {
//         fetchCatalogDetails(selectedMonth);
//         setModalOpen(true);
//     };

//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             {/* --- TOP CONTROL BAR --- */}
//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 200 }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading}>
//                         {t("PRESENT DATA")}
//                     </Button>
//                 </Box>
                
//                 <Box sx={{ display: 'flex', gap: 2 }}>
//                     <Button variant="contained" color="secondary" onClick={handleOpenCatalog} disabled={loading}>
//                         {t("VIEW CATALOG DETAILS")}
//                     </Button>

//                     <Button 
//                         variant="contained" 
//                         color="success" 
//                         startIcon={downloading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadIcon />}
//                         onClick={downloadCatalogExcel}
//                         disabled={loading || downloading}
//                     >
//                         {downloading ? t("DOWNLOADING...") : t("DOWNLOAD EXCEL")}
//                     </Button>
//                 </Box>
//             </Paper>

//             {/* --- CHART SECTION --- */}
//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', minHeight: 450, borderRadius: 2 }}>
//                 {loading && !modalOpen ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none' }} />
//                             <Legend />
//                             <Bar dataKey="total" fill="#8884d8" name={t("Issues Completed")} radius={[4, 4, 0, 0]} />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available for this month")}</Typography>
//                 )}
//             </Paper>

//             {/* --- CATALOG MODAL --- */}
//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '95%', maxWidth: 1100, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, 
//                     boxShadow: 24, color: 'white', border: '1px solid #3d3d5c'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
//                             <Typography variant="h6">{t("Issue Resolution Catalog")}</Typography>
                            
//                             {/* ✅ DATE PICKER INSIDE MODAL */}
//                             <TextField 
//                                 label={t("Filter Period")}
//                                 type="month" 
//                                 size="small"
//                                 value={selectedMonth}
//                                 onChange={(e) => {
//                                     const newMonth = e.target.value;
//                                     setSelectedMonth(newMonth);
//                                     fetchCatalogDetails(newMonth); // 🔥 REFRESHES TABLE IMMEDIATELY
//                                 }}
//                                 InputLabelProps={{ shrink: true }}
//                                 sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 180 }}
//                             />
//                         </Box>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}>
//                             <CloseIcon />
//                         </IconButton>
//                     </Box>

//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Reported")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Resolved")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white', fontWeight: 'bold' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {loading ? (
//                                     <TableRow>
//                                         <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
//                                             <CircularProgress />
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : details.length > 0 ? (
//                                     details.map((row, i) => (
//                                         <TableRow key={i} hover sx={{ '&:hover': { bgcolor: '#3d3d5c !important' } }}>
//                                             <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.room}</TableCell>
//                                             <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.staff}</TableCell>
//                                             <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.issue}</TableCell>
//                                             <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.reported}</TableCell>
//                                             <TableCell sx={{ color: '#ccc', borderBottom: '1px solid #3d3d5c' }}>{row.resolved}</TableCell>
//                                             <TableCell sx={{ color: '#8884d8', fontWeight: 'bold', borderBottom: '1px solid #3d3d5c' }}>
//                                                 {formatTimeTaken(row.time_taken)}
//                                             </TableCell>
//                                         </TableRow>
//                                     ))
//                                 ) : (
//                                     <TableRow>
//                                         <TableCell colSpan={6} align="center" sx={{ color: '#999', py: 10 }}>
//                                             {t("No details for this period")}
//                                         </TableCell>
//                                     </TableRow>
//                                 )}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;

//////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import { 
//     Box, Typography, Paper, TextField, Button, 
//     Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//     CircularProgress, IconButton, Grid 
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Cell } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); 
//     const [details, setDetails] = useState([]); 
//     const [loading, setLoading] = useState(false);
//     const [downloading, setDownloading] = useState(false); 
//     const [modalOpen, setModalOpen] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//     const formatTimeTaken = (timeValue) => {
//         const hours = parseFloat(timeValue);
//         if (isNaN(hours)) return timeValue;
//         const totalMinutes = Math.round(hours * 60);
//         if (totalMinutes <= 0) return `0 ${t("mins")}`;
//         if (totalMinutes < 60) return `${totalMinutes} ${t("mins")}`;
//         return `${hours.toFixed(1)} ${t("hrs")}`;
//     };

//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", { params: { start, end } });
//             setData(response.data);
//         } catch (error) {
//             console.error("Stats Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     const fetchCatalogDetails = async (targetMonth) => {
//         setLoading(true);
//         const start = dayjs(targetMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(targetMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", { params: { start, end } });
//             setDetails(response.data);
//         } catch (error) {
//             setDetails([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleOpenCatalog = () => {
//         fetchCatalogDetails(selectedMonth);
//         setModalOpen(true);
//     };

//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             {/* --- CONTROLS --- */}
//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 200 }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading}>{t("PRESENT DATA")}</Button>
//                 </Box>
                
//                 <Box sx={{ display: 'flex', gap: 2 }}>
//                     <Button variant="contained" color="secondary" onClick={handleOpenCatalog}>{t("VIEW CATALOG")}</Button>
//                 </Box>
//             </Paper>

//             {/* --- CHARTS GRID --- */}
//             <Grid container spacing={3}>
//                 {/* 1. ISSUES COMPLETED CHART */}
//                 <Grid item xs={12} lg={6}>
//                     <Paper sx={{ p: 3, bgcolor: '#1e1e2f', borderRadius: 2, minHeight: 450 }}>
//                         <Typography variant="h6" sx={{ color: '#8884d8', mb: 2, fontWeight: 'bold' }}>
//                             {t("Issues Completed")}
//                         </Typography>
//                         {loading ? <CircularProgress /> : (
//                             <ResponsiveContainer width="100%" height={350}>
//                                 <BarChart data={data}>
//                                     <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                                     <XAxis dataKey="name" stroke="#ccc" fontSize={12} />
//                                     <YAxis stroke="#ccc" />
//                                     <Tooltip contentStyle={{ backgroundColor: '#2d2d44', border: 'none', color: '#fff' }} />
//                                     <Bar dataKey="total" fill="#8884d8" radius={[4, 4, 0, 0]} name={t("Total Issues")} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         )}
//                     </Paper>
//                 </Grid>

//                 {/* 2. AVG RESOLUTION TIME CHART */}
//                 <Grid item xs={12} lg={6}>
//                     <Paper sx={{ p: 3, bgcolor: '#1e1e2f', borderRadius: 2, minHeight: 450 }}>
//                         <Typography variant="h6" sx={{ color: '#82ca9d', mb: 2, fontWeight: 'bold' }}>
//                             {t("Avg. Resolution Time (Hours)")}
//                         </Typography>
//                         {loading ? <CircularProgress /> : (
//                             <ResponsiveContainer width="100%" height={350}>
//                                 <BarChart data={data}>
//                                     <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                                     <XAxis dataKey="name" stroke="#ccc" fontSize={12} />
//                                     <YAxis stroke="#ccc" />
//                                     <Tooltip 
//                                         contentStyle={{ backgroundColor: '#2d2d44', border: 'none', color: '#fff' }}
//                                         formatter={(value) => [`${value} ${t("hrs")}`, t("Average Time")]}
//                                     />
//                                     <Bar dataKey="avg_time" fill="#82ca9d" radius={[4, 4, 0, 0]} name={t("Avg Hours")} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         )}
//                     </Paper>
//                 </Grid>
//             </Grid>

//             {/* --- MODAL CATALOG --- */}
//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '95%', maxWidth: 1100, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, color: 'white'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//                         <Typography variant="h6">{t("Issue Resolution Catalog")}</Typography>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}><CloseIcon /></IconButton>
//                     </Box>
//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {details.map((row, i) => (
//                                     <TableRow key={i}>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.room}</TableCell>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.staff}</TableCell>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.issue}</TableCell>
//                                         <TableCell sx={{ color: '#82ca9d', fontWeight: 'bold' }}>
//                                             {formatTimeTaken(row.time_taken)}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;


////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import { 
//     Box, Typography, Paper, TextField, Button, 
//     Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//     CircularProgress, IconButton, Stack
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import TimerIcon from "@mui/icons-material/Timer";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); 
//     const [details, setDetails] = useState([]); 
//     const [loading, setLoading] = useState(false);
//     const [modalOpen, setModalOpen] = useState(false);
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));
    
//     // ✅ NEW STATE: Toggle between 'volume' and 'average'
//     const [activeGraph, setActiveGraph] = useState("volume"); 

//     const formatTimeTaken = (timeValue) => {
//         const hours = parseFloat(timeValue);
//         if (isNaN(hours)) return timeValue;
//         const totalMinutes = Math.round(hours * 60);
//         if (totalMinutes <= 0) return `0 ${t("mins")}`;
//         if (totalMinutes < 60) return `${totalMinutes} ${t("mins")}`;
//         return `${hours.toFixed(1)} ${t("hrs")}`;
//     };

//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", { params: { start, end } });
//             setData(response.data);
//         } catch (error) {
//             console.error("Stats Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     const fetchCatalogDetails = async (targetMonth) => {
//         setLoading(true);
//         const start = dayjs(targetMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(targetMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", { params: { start, end } });
//             setDetails(response.data);
//         } catch (error) { setDetails([]); }
//         finally { setLoading(false); }
//     };

//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             {/* --- CONTROLS --- */}
//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//                 <Stack direction="row" spacing={2} alignItems="center">
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ input: { color: 'white' }, bgcolor: '#2d2d44', borderRadius: 1, width: 180 }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading}>{t("PRESENT DATA")}</Button>
//                 </Stack>
                
//                 <Stack direction="row" spacing={2}>
//                     {/* ✅ TOGGLE BUTTONS */}
//                     <Button 
//                         variant={activeGraph === "volume" ? "contained" : "outlined"} 
//                         color="primary"
//                         startIcon={<BarChartIcon />}
//                         onClick={() => setActiveGraph("volume")}
//                     >
//                         {t("Show Completed")}
//                     </Button>

//                     <Button 
//                         variant={activeGraph === "average" ? "contained" : "outlined"} 
//                         color="success"
//                         startIcon={<TimerIcon />}
//                         onClick={() => setActiveGraph("average")}
//                     >
//                         {t("Show Avg. Time")}
//                     </Button>

//                     <Button variant="contained" color="secondary" onClick={() => { fetchCatalogDetails(selectedMonth); setModalOpen(true); }}>
//                         {t("VIEW CATALOG")}
//                     </Button>
//                 </Stack>
//             </Paper>

//             {/* --- GRAPH CONTAINER --- */}
//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', borderRadius: 2, minHeight: 480 }}>
//                 <Typography variant="h6" sx={{ color: activeGraph === "volume" ? "#8884d8" : "#82ca9d", mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
//                     {activeGraph === "volume" ? t("Issues Completed") : t("Avg. Resolution Time (Hours)")}
//                 </Typography>

//                 {loading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" fontSize={12} />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip 
//                                 contentStyle={{ backgroundColor: '#2d2d44', border: 'none', color: '#fff' }} 
//                                 formatter={(value) => activeGraph === "average" ? [`${value} ${t("hrs")}`, t("Avg. Time")] : [value, t("Total Issues")]}
//                             />
//                             <Legend />
//                             {activeGraph === "volume" ? (
//                                 <Bar dataKey="total" fill="#8884d8" radius={[4, 4, 0, 0]} name={t("Total Issues")} />
//                             ) : (
//                                 <Bar dataKey="avg_time" fill="#82ca9d" radius={[4, 4, 0, 0]} name={t("Avg. Hours")} />
//                             )}
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available")}</Typography>
//                 )}
//             </Paper>

//             {/* --- MODAL CATALOG (Hidden until clicked) --- */}
//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '95%', maxWidth: 1100, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, color: 'white', border: '1px solid #3d3d5c'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//                         <Typography variant="h6">{t("Issue Resolution Catalog")}</Typography>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}><CloseIcon /></IconButton>
//                     </Box>
//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {details.map((row, i) => (
//                                     <TableRow key={i}>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.room}</TableCell>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.staff}</TableCell>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.issue}</TableCell>
//                                         <TableCell sx={{ color: '#82ca9d', fontWeight: 'bold' }}>
//                                             {formatTimeTaken(row.time_taken)}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;


// import React, { useState, useEffect, useCallback } from "react";
// import { 
//     Box, Typography, Paper, TextField, Button, 
//     Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
//     CircularProgress, IconButton, Stack
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import TimerIcon from "@mui/icons-material/Timer";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const StaffPerformance = () => {
//     const { t } = useTranslation();
//     const [data, setData] = useState([]); 
//     const [details, setDetails] = useState([]); 
//     const [loading, setLoading] = useState(false);
//     const [modalOpen, setModalOpen] = useState(false);
    
//     // ✅ RESTORED: This is your main date filter
//     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));
    
//     // ✅ TOGGLE STATE: Choose which graph to show
//     const [activeGraph, setActiveGraph] = useState("volume"); 

//     const formatTimeTaken = (timeValue) => {
//         const hours = parseFloat(timeValue);
//         if (isNaN(hours)) return timeValue;
//         const totalMinutes = Math.round(hours * 60);
//         if (totalMinutes <= 0) return `0 ${t("mins")}`;
//         if (totalMinutes < 60) return `${totalMinutes} ${t("mins")}`;
//         return `${hours.toFixed(1)} ${t("hrs")}`;
//     };

//     // ✅ FETCH STATS: Uses the selectedMonth state
//     const fetchStats = useCallback(async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-performance-stats/", { params: { start, end } });
//             setData(response.data);
//         } catch (error) {
//             console.error("Stats Fetch Error:", error);
//             setData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedMonth]);

//     const fetchCatalogDetails = async () => {
//         setLoading(true);
//         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
//         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
//         try {
//             const response = await axiosClient.get("/api/staff-issue-details/", { params: { start, end } });
//             setDetails(response.data);
//         } catch (error) { 
//             setDetails([]); 
//         } finally { 
//             setLoading(false); 
//         }
//     };

//     // Auto-fetch when the month changes
//     useEffect(() => {
//         fetchStats();
//     }, [fetchStats]);

//     const handleOpenCatalog = () => {
//         fetchCatalogDetails();
//         setModalOpen(true);
//     };

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
//                 {t("STAFF PERFORMANCE")}
//             </Typography>

//             {/* --- TOP CONTROL BAR (Date Picker is back!) --- */}
//             <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//                 <Stack direction="row" spacing={2} alignItems="center">
//                     <TextField 
//                         label={t("Select Month")}
//                         type="month" 
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ 
//                             input: { color: 'white' }, 
//                             bgcolor: '#2d2d44', 
//                             borderRadius: 1, 
//                             width: 200,
//                             "& .MuiInputLabel-root": { color: "#aaa" }
//                         }}
//                     />
//                     <Button variant="contained" onClick={fetchStats} disabled={loading}>{t("PRESENT DATA")}</Button>
//                 </Stack>
                
//                 <Stack direction="row" spacing={2}>
//                     {/* TOGGLE BUTTONS FOR GRAPHS */}
//                     <Button 
//                         variant={activeGraph === "volume" ? "contained" : "outlined"} 
//                         color="primary"
//                         startIcon={<BarChartIcon />}
//                         onClick={() => setActiveGraph("volume")}
//                     >
//                         {t("Show Completed")}
//                     </Button>

//                     <Button 
//                         variant={activeGraph === "average" ? "contained" : "outlined"} 
//                         color="success"
//                         startIcon={<TimerIcon />}
//                         onClick={() => setActiveGraph("average")}
//                     >
//                         {t("Show Avg. Time")}
//                     </Button>

//                     <Button variant="contained" color="secondary" onClick={handleOpenCatalog}>
//                         {t("VIEW CATALOG")}
//                     </Button>
//                 </Stack>
//             </Paper>

//             {/* --- GRAPH CONTAINER --- */}
//             <Paper sx={{ p: 4, bgcolor: '#1e1e2f', borderRadius: 2, minHeight: 480 }}>
//                 <Typography variant="h6" sx={{ color: activeGraph === "volume" ? "#8884d8" : "#82ca9d", mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
//                     {activeGraph === "volume" ? t("Issues Completed") : t("Avg. Resolution Time (Hours)")}
//                 </Typography>

//                 {loading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
//                 ) : data.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={400}>
//                         <BarChart data={data}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#444" />
//                             <XAxis dataKey="name" stroke="#ccc" fontSize={12} />
//                             <YAxis stroke="#ccc" />
//                             <Tooltip 
//                                 contentStyle={{ backgroundColor: '#2d2d44', border: 'none', color: '#fff' }} 
//                                 formatter={(value) => activeGraph === "average" ? [`${value} ${t("hrs")}`, t("Avg. Time")] : [value, t("Total Issues")]}
//                             />
//                             <Legend />
//                             {activeGraph === "volume" ? (
//                                 <Bar dataKey="total" fill="#8884d8" radius={[4, 4, 0, 0]} name={t("Total Issues")} />
//                             ) : (
//                                 <Bar dataKey="avg_time" fill="#82ca9d" radius={[4, 4, 0, 0]} name={t("Avg. Hours")} />
//                             )}
//                         </BarChart>
//                     </ResponsiveContainer>
//                 ) : (
//                     <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available")}</Typography>
//                 )}
//             </Paper>

//             {/* --- MODAL CATALOG --- */}
//             <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
//                 <Box sx={{ 
//                     position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//                     width: '95%', maxWidth: 1100, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, color: 'white', border: '1px solid #3d3d5c'
//                 }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//                         <Typography variant="h6">{t("Issue Resolution Catalog")} ({dayjs(selectedMonth).format("MMMM YYYY")})</Typography>
//                         <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}><CloseIcon /></IconButton>
//                     </Box>
//                     <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Room")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Staff")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Issue")}</TableCell>
//                                     <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Time")}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {details.map((row, i) => (
//                                     <TableRow key={i}>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.room}</TableCell>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.staff}</TableCell>
//                                         <TableCell sx={{ color: '#ccc' }}>{row.issue}</TableCell>
//                                         <TableCell sx={{ color: '#82ca9d', fontWeight: 'bold' }}>
//                                             {formatTimeTaken(row.time_taken)}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default StaffPerformance;



/////////////////////////////


import React, { useState, useEffect, useCallback } from "react";
import { 
    Box, Typography, Paper, TextField, Button, 
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, 
    CircularProgress, IconButton, Stack
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BarChartIcon from "@mui/icons-material/BarChart";
import TimerIcon from "@mui/icons-material/Timer";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import axiosClient from "../axiosClient";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const StaffPerformance = () => {
    const { t } = useTranslation();
    const [data, setData] = useState([]); 
    const [details, setDetails] = useState([]); 
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));
    const [activeGraph, setActiveGraph] = useState("volume"); 

    // ✅ Cleaned up: Just return the string from backend or a fallback
    const formatTimeDisplay = (timeValue) => {
        if (!timeValue) return `0 ${t("mins")}`;
        return timeValue; // Backend already sends "1h 20m" or "45m"
    };

    const fetchStats = useCallback(async () => {
        setLoading(true);
        const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
        const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        try {
            // const response = await axiosClient.get("/api/staff-performance-stats/", { params: { start, end } });
            const response = await axiosClient.get("staff-performance-stats/", { params: { start, end } });
            setData(response.data);
        } catch (error) {
            console.error("Stats Fetch Error:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    }, [selectedMonth]);

    const fetchCatalogDetails = async () => {
        setLoading(true);
        const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
        const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        try {
            // const response = await axiosClient.get("/api/staff-issue-details/", { params: { start, end } });
            const response = await axiosClient.get("staff-issue-details/", { params: { start, end } });
            setDetails(response.data);
        } catch (error) { 
            setDetails([]); 
        } finally { 
            setLoading(false); 
        }
    };

    useEffect(() => {
        fetchStats();
    }, [fetchStats]);

    const handleOpenCatalog = () => {
        fetchCatalogDetails();
        setModalOpen(true);
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
                {t("STAFF PERFORMANCE")}
            </Typography>

            <Paper sx={{ p: 3, mb: 3, bgcolor: '#1e1e2f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <TextField 
                        label={t("Select Month")}
                        type="month" 
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ 
                            input: { color: 'white' }, 
                            bgcolor: '#2d2d44', 
                            borderRadius: 1, 
                            width: 200,
                            "& .MuiInputLabel-root": { color: "#aaa" }
                        }}
                    />
                    <Button variant="contained" onClick={fetchStats} disabled={loading}>{t("PRESENT DATA")}</Button>
                </Stack>
                
                <Stack direction="row" spacing={2}>
                    <Button 
                        variant={activeGraph === "volume" ? "contained" : "outlined"} 
                        color="primary"
                        startIcon={<BarChartIcon />}
                        onClick={() => setActiveGraph("volume")}
                    >
                        {t("Show Completed")}
                    </Button>

                    <Button 
                        variant={activeGraph === "average" ? "contained" : "outlined"} 
                        color="success"
                        startIcon={<TimerIcon />}
                        onClick={() => setActiveGraph("average")}
                    >
                        {t("Show Avg. Time")}
                    </Button>

                    <Button variant="contained" color="secondary" onClick={handleOpenCatalog}>
                        {t("VIEW CATALOG")}
                    </Button>
                </Stack>
            </Paper>

            <Paper sx={{ p: 4, bgcolor: '#1e1e2f', borderRadius: 2, minHeight: 480 }}>
                <Typography variant="h6" sx={{ color: activeGraph === "volume" ? "#8884d8" : "#82ca9d", mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
                    {activeGraph === "volume" ? t("Issues Completed") : t("Avg. Resolution Time (Hours)")}
                </Typography>

                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>
                ) : data.length > 0 ? (
                    <ResponsiveContainer width="100%" height={400}>
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                            <XAxis dataKey="name" stroke="#ccc" fontSize={12} />
                            <YAxis stroke="#ccc" />
                            <Tooltip 
                                contentStyle={{ backgroundColor: '#2d2d44', border: 'none', color: '#fff' }} 
                                formatter={(value) => activeGraph === "average" ? [`${value} ${t("hrs")}`, t("Avg. Time")] : [value, t("Total Issues")]}
                            />
                            <Legend />
                            {activeGraph === "volume" ? (
                                <Bar dataKey="total" fill="#8884d8" radius={[4, 4, 0, 0]} name={t("Total Issues")} />
                            ) : (
                                <Bar dataKey="avg_time" fill="#82ca9d" radius={[4, 4, 0, 0]} name={t("Avg. Hours")} />
                            )}
                        </BarChart>
                    </ResponsiveContainer>
                ) : (
                    <Typography align="center" sx={{ py: 10, color: '#666' }}>{t("No data available")}</Typography>
                )}
            </Paper>

            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <Box sx={{ 
                    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                    width: '95%', maxWidth: 1100, bgcolor: '#1e1e2f', p: 4, borderRadius: 2, color: 'white', border: '1px solid #3d3d5c'
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="h6">{t("Issue Resolution Catalog")} ({dayjs(selectedMonth).format("MMMM YYYY")})</Typography>
                        <IconButton onClick={() => setModalOpen(false)} sx={{ color: 'white' }}><CloseIcon /></IconButton>
                    </Box>
                    <TableContainer component={Paper} sx={{ maxHeight: 500, bgcolor: '#2d2d44' }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Room")}</TableCell>
                                    <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Staff")}</TableCell>
                                    <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Issue")}</TableCell>
                                    <TableCell sx={{ bgcolor: '#3d3d5c', color: 'white' }}>{t("Time")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {details.map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell sx={{ color: '#ccc' }}>{row.room}</TableCell>
                                        <TableCell sx={{ color: '#ccc' }}>{row.staff}</TableCell>
                                        <TableCell sx={{ color: '#ccc' }}>{row.issue}</TableCell>
                                        <TableCell sx={{ color: '#82ca9d', fontWeight: 'bold' }}>
                                            {/* ✅ Using the backend string directly */}
                                            {formatTimeDisplay(row.time_taken)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Modal>
        </Box>
    );
};

export default StaffPerformance;